import { createSelector } from '@reduxjs/toolkit';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

/**
 * Enables the view more button and related screens for advancement details
 * like merit badges, ranks, etc. for Beta Units
 */
export const SBL_5746_betaUnitsSel = createSelector(
  organizationGuidSel,
  currentOrgGuid => {
    const flag = featureFlags.getFlag(
      'SBL_5746_ENABLE_ADV_BETA_UNITS',
    ) as string;
    const unitGuids = new Set(flag?.split(','));
    if (unitGuids.size === 0) return false;
    const show = unitGuids.has(currentOrgGuid);
    return show;
  },
);

export const SBL_4463_betaUnitsSel = createSelector(
  SBL_5746_betaUnitsSel,
  isInBetaUnit => {
    const flag = featureFlags.getFlag('SBL_4463_ADVANCEMENTS_TAB');

    if (flag) return true;

    const betaFlag = featureFlags.getFlag('SBL_4463_BETA_PO');

    return isInBetaUnit && betaFlag;
  },
);
